import {
  ReferralTypeModel,
  IReferralTypeModel,
} from '@common/models/ReferralTypeModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ReferralTypeService {
  private static baseUrl: string = '/api/referraltype';

  static tags = {
    referralType: 'referralType',
  };

  static upsertReferralType = (
    data: IReferralTypeModel,
    options?: ServiceMethodOptions,
  ): Promise<ReferralTypeModel> => {
    return trackPromise(
      new Promise<IReferralTypeModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IReferralTypeModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Referral Type updated.', options);
            resolve(new ReferralTypeModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Referral Type.', options);
            reject(err);
          });
      }),
      this.tags.referralType,
    );
  };

  static deleteReferralType = (
    referralTypeId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${referralTypeId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Referral Type has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Referral Type.', options);
            reject(err);
          });
      }),
      this.tags.referralType,
    );
  };
}
